const appRoutes = {
  root: '/',
  register: '/register',
  verification: '/verification',
  confirmActive: '/confirm-active',
  guestInvitation: '/invitation',
  unregister: '/unregister'
};

export { appRoutes };
